import { lazy } from 'react';

// project imports
import MinimalLayout from 'layout/MinimalLayout';
import Loadable from 'ui-component/Loadable';
import ErrorBoundary from './ErrorBoundary';

// public pages routing
const PrivacyPolicy = Loadable(lazy(() => import('views/pages/saas-pages/PrivacyPolicy')));
const TermsOfService = Loadable(lazy(() => import('views/pages/saas-pages/TermsOfService')));

// ==============================|| PUBLIC ROUTING ||============================== //

const PublicRoutes = {
  element: <MinimalLayout />,
  errorElement: <ErrorBoundary />,
  children: [
    {
      path: '/privacy-policy',
      element: <PrivacyPolicy />
    },
    {
      path: '/terms-of-service',
      element: <TermsOfService />
    }
  ]
};

export default PublicRoutes;
